export default __webpack_public_path__ + "static/media/green-tick.53a7e909.svg";